import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTipoCodigoPromocionesComponent } from "./edit-tipo-codigo-promociones/edit-tipo-codigo-promociones.component";

@Component({
  selector: "app-tipo-codigo-promociones",
  templateUrl: "./tipo-codigo-promociones.component.html",
  styleUrls: ["./tipo-codigo-promociones.component.scss"],
})
export class TipoCodigoPromocionesComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTipoCodigoPromocionesComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
